module.exports = __webpack_public_path__ + "static/media/0323_IMG_KIOSQUE_LES_ENSEIGNES_LES_FROMAGES_SCRABBLE.961d8431.webp";